// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header__sectionSmall___NIFdM {
}

.Header__row___lTDhp {
}

.Header__ticketFlag___LjSwA {
  display: inline-block;
  height: 25px;
  margin: 0;
  padding: 0;
}

.Header__ticketFlag___LjSwA img {
    height: 25px;
    margin-right: 5px;
  }

.Header__boxLabel___DSDIJ {
  line-height: 26px;
  margin: 0;
}

.Header__headerLight___r7O41 {
  margin-top: 5px;
  color: #7D7D7D;
}

.Header__headerLight___r7O41 h4 {
    margin-top: 3px;
    font-weight: 400;
  }

.Header__nameWrapper___axLme {
  width: calc(99.9% * 3/5 - (30px - 30px * 3/5));
}

.Header__nameWrapper___axLme:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.Header__nameWrapper___axLme:last-child {
  margin-right: 0;
}

.Header__nameWrapper___axLme:nth-child(5n) {
  margin-right: 0;
  float: right;
}

.Header__nameWrapper___axLme:nth-child(5n + 1) {
  clear: both;
}

.Header__nameWrapper___axLme .Header__boxLabel___DSDIJ {
    margin-right: 20px;
  }

.Header__beneName___DxmFw {
  box-shadow: none;
  color: text;
}

.Header__balanceWrapper___y72nx {
  width: calc(99.9% * 2/5 - (30px - 30px * 2/5));
  text-align: right;
}

.Header__balanceWrapper___y72nx:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.Header__balanceWrapper___y72nx:last-child {
  margin-right: 0;
}

.Header__balanceWrapper___y72nx:nth-child(1n) {
  margin-right: 0;
  float: right;
}

.Header__balanceWrapper___y72nx:nth-child(1n + 1) {
  clear: both;
}

.Header__standardHeight___HBrSD {
  min-height: 100px;
}

.Header__trusts___RvopJ {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: -10px;
  margin-top: -5px;
}

.Header__trusts___RvopJ a {
  margin: 0 10px 0 0;
}

.Header__trustsItem___SIqVu {
  margin: 0 10px;
  display: inline-block;
  vertical-align: middle;
}

.Header__titleBox___OK6r6 {
  position: relative;
}

.Header__titleName___zkAJc {
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
}

.Header__accountNumberLine___TCgyx {
  display: flex;
  align-items: center;
  justify-content: left;
  margin-top: 8px;
}

.Header__accountNumber___g7P58 {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  margin-bottom: 5px;
  padding: 2px 4px;
  vertical-align: middle;
}

.Header__closedStatus___PAhWJ {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 10px;
  padding: 2px 4px;
  vertical-align: middle;
}

.Header__closingStatus___AsuaM {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 10px;
  padding: 2px 4px;
  vertical-align: middle;
}

.Header__deceasedFlag___CK6Vd {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  float: left;
  margin-bottom: 5px;
  margin-left: 10px;
  padding: 2px 4px;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Number/Main/Header/Header.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;AAEA;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,UAAU;AAMZ;;AAJE;IACE,YAAY;IACZ,iBAAiB;EACnB;;AAGF;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAMhB;;AAJE;IACE,eAAe;IACf,gBAAgB;EAClB;;AAGF;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;IACE,kBAAkB;EACpB;;AAGF;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,8CAAkB;EAClB,iBAAiB;AACnB;;AAHA;EACE,WAAkB;EAAlB,kBAAkB;EAAlB,WAAkB;AAEpB;;AAHA;EACE,eAAkB;AAEpB;;AAHA;EACE,eAAkB;EAAlB,YAAkB;AAEpB;;AAHA;EACE,WAAkB;AAEpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,wDAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wDAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wDAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wDAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: 'styles/colors.css';\n@value gtGPT, gtRedDark, gtYellowDark, textLight from colors;\n\n.sectionSmall {\n  composes: sectionSmall from helpers;\n}\n\n.row {\n  composes: row from helpers;\n}\n\n.ticketFlag {\n  display: inline-block;\n  height: 25px;\n  margin: 0;\n  padding: 0;\n\n  & img {\n    height: 25px;\n    margin-right: 5px;\n  }\n}\n\n.boxLabel {\n  line-height: 26px;\n  margin: 0;\n}\n\n.headerLight {\n  margin-top: 5px;\n  color: #7D7D7D;\n\n  & h4 {\n    margin-top: 3px;\n    font-weight: 400;\n  }\n}\n\n.nameWrapper {\n  lost-column: 3/5;\n\n  .boxLabel {\n    margin-right: 20px;\n  }\n}\n\n.beneName {\n  box-shadow: none;\n  color: text;\n}\n\n.balanceWrapper {\n  lost-column: 2/5 1;\n  text-align: right;\n}\n\n.standardHeight {\n  min-height: 100px;\n}\n\n.trusts {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: -10px;\n  margin-top: -5px;\n}\n\n.trusts a {\n  margin: 0 10px 0 0;\n}\n\n.trustsItem {\n  margin: 0 10px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.titleBox {\n  composes: sectionSmall row;\n  position: relative;\n}\n\n.titleName {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 5px;\n}\n\n.accountNumberLine {\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  margin-top: 8px;\n}\n\n.accountNumber {\n  background: gtGPT;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  margin-bottom: 5px;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n\n.closedStatus {\n  background: gtRedDark;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  margin-bottom: 5px;\n  margin-left: 10px;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n\n.closingStatus {\n  background: gtYellowDark;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  margin-bottom: 5px;\n  margin-left: 10px;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n\n.deceasedFlag {\n  background: gtRedDark;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  float: left;\n  margin-bottom: 5px;\n  margin-left: 10px;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `'styles/colors.css'`,
	"gtGPT": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]}`,
	"gtRedDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"sectionSmall": `Header__sectionSmall___NIFdM ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]}`,
	"row": `Header__row___lTDhp ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"ticketFlag": `Header__ticketFlag___LjSwA`,
	"boxLabel": `Header__boxLabel___DSDIJ`,
	"headerLight": `Header__headerLight___r7O41`,
	"nameWrapper": `Header__nameWrapper___axLme`,
	"beneName": `Header__beneName___DxmFw`,
	"balanceWrapper": `Header__balanceWrapper___y72nx`,
	"standardHeight": `Header__standardHeight___HBrSD`,
	"trusts": `Header__trusts___RvopJ`,
	"trustsItem": `Header__trustsItem___SIqVu`,
	"titleBox": `Header__titleBox___OK6r6 Header__sectionSmall___NIFdM ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]} Header__row___lTDhp ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"titleName": `Header__titleName___zkAJc`,
	"accountNumberLine": `Header__accountNumberLine___TCgyx`,
	"accountNumber": `Header__accountNumber___g7P58`,
	"closedStatus": `Header__closedStatus___PAhWJ`,
	"closingStatus": `Header__closingStatus___AsuaM`,
	"deceasedFlag": `Header__deceasedFlag___CK6Vd`
};
export default ___CSS_LOADER_EXPORT___;
